var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"fondo"},[_vm._v(" Servicios ")])
}
var staticRenderFns = []

export { render, staticRenderFns }